import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

import { FeedItemEventDateModule } from '@main-client/src/app/feed/feed-item-event/feed-item-event-date/feed-item-event-date.module';
import { FeedItemEventMeetingMethodModule } from '@main-client/src/app/feed/feed-item-event/feed-item-event-meeting-method/feed-item-event-meeting-method.module';
import { PermittedEventLocationPipeModule } from '@main-client/src/app/pipes/permitted-event-location-pipe/permitted-event-location-pipe.module';
import { ProgressSpinnerModule } from '@main-client/src/app/progress-spinner/progress-spinner.module';

import { ProfileOpportunitiesComponent } from '@main-client/src/app/profile/profile-opportunities/profile-opportunities.component';

@NgModule({
  imports: [
    CommonModule,
    FeedItemEventDateModule,
    FeedItemEventMeetingMethodModule,
    FlexLayoutModule,
    PermittedEventLocationPipeModule,
    ProgressSpinnerModule,
    RouterModule.forChild([]),
  ],
  declarations: [ProfileOpportunitiesComponent],
  exports: [ProfileOpportunitiesComponent],
})
export class ProfileOpportunitiesModule {}
